import React from 'react';

export default function CVIcon({ className }) {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.97772 0.545454L0.250444 6.27273L5.97772 12L6.96209 11.0156L2.90953 6.97585L13.4053 6.97585L13.4053 5.5696L2.90954 5.5696L6.96209 1.51704L5.97772 0.545454Z" fill="#4D4D4D" fill-opacity="0.9"/>
    </svg>
  );
}
